import React from 'react';
import { TYPE } from '../../../constant';
import { useUserInfo } from '../../../hooks';
import { StarCntBtn } from '../../common';
import { MenuButton } from '../../navigate';
import HeaderButton from '../../common/header/HeaderButton';

function Header() {
  const { info } = useUserInfo();
  return (
    <div className="header_top gm">
      <div className="inner">
        <div className="btns_wrap header-trans cls">
          <div className="center_wrap cls pc_w1400">
            {
              info.entryType !== TYPE.ENTRY_TYPE.GM_APP && (
                <div className="tit_area">
                  <HeaderButton
                    buttons={[
                      { cs: 'btn_exit hide_m', img: 'static/images/icon/ic_back@2x.png' },
                      { cs: 'btn_exit2', img: 'static/images/icon/ic_ar_left.svg' }
                    ]}
                  />
                </div>
              )
            }
            <div className="right_area">
              <div className="menu_btn">
                <StarCntBtn type="button" />
                <MenuButton
                  isNote={true}
                  csNote={"purple"}
                  iconPath="static/images/icon/ic_mn_w@2x.png"
                  noteIcon={"static/images/icon/ic_gm_note_2@2x.png"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;